var KModalImportMode;
(function (KModalImportMode) {
    KModalImportMode["Upload"] = "UPLOAD";
    KModalImportMode["Indexing"] = "INDEXING";
    KModalImportMode["Success"] = "SUCCESS";
})(KModalImportMode || (KModalImportMode = {}));

export { KModalImportMode };
//# sourceMappingURL=types.js.map
